import React, { createContext, useContext, useEffect, useState } from 'react';
import api from './api';

const DEFAULT = {
  brand_name: 'CAPIN',
  brand_suffix: 'Realty',
  city: 'Pune',
  tagline_top: 'Your Trusted',
  tagline_accent: 'Real Estate',
  tagline_bottom: 'Partner in Pune',
  subtitle: 'Premium properties, expert guidance, and seamless transactions for your dream investment.',
  stats: [
    { value: '500+', label: 'Properties Listed' },
    { value: '200+', label: 'Happy Clients' },
    { value: '15+', label: 'Years Experience' },
  ],
  background_url: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80',
  logo_url: '/capin-logo.jpg',
  logo_monogram: 'CR',
  footer_text: '© 2025 CAPIN Realty. All rights reserved.',
  location_text: 'Pune, Maharashtra, India',
};

const Ctx = createContext({ branding: DEFAULT, refresh: () => {} });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT);
  const refresh = async () => {
    try {
      const { data } = await api.get('/public/branding');
      setBranding({ ...DEFAULT, ...data });
    } catch { /* keep defaults */ }
  };
  useEffect(() => { refresh(); }, []);
  return <Ctx.Provider value={{ branding, refresh, setBranding }}>{children}</Ctx.Provider>;
}

export const useBranding = () => useContext(Ctx);
